// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.Pagination_dashboard__kQixg {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.Pagination_dashboardContain__0pA47 {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.Pagination_bodythemedark__OgYY8 .Pagination_dashboardContain__0pA47,
.Pagination_bodythemedark__OgYY8 .Pagination_dashboard__kQixg,
.Pagination_bodythemedark__OgYY8 .Pagination_cont2__SZIEC {
  background-Color: #0f1824;
}

.Pagination_top_header__H-Oco .Pagination_top_header_inner__PaHcf {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.Pagination_cont2__SZIEC {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.Pagination_subLink__ZBQ8s svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.Pagination_cst_vendr__rcwk- input {
  min-height: 35px !important;
}

.Pagination_cst_vendr__rcwk- .Pagination_form-control__M0GGh {
  background-color: #f5f6fa;
  border: none;
}

.Pagination_footer__b0mH- {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.Pagination_bodythemelight__R2JcG {
  background-color: #fff;
  padding-top: 90px;
}

.Pagination_bodythemedark__OgYY8 {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.Pagination_headerthemelight__-7Cfo {
  background-color: #fff;
}

.Pagination_headerthemedark__r4EaC {
  background-color: #132337;
}

.Pagination_top_header__H-Oco {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.Pagination_menuthemelight__k4gQv {
  background-color: #fff;
}

.Pagination_menuthemedark__cLgRf {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.Pagination_menulinklight__sX78A span {
  color: #666666 !important;
}

.Pagination_menulinklight__sX78A a {
  color: #CBCBCB !important;
}

.Pagination_menulinklight__sX78A:hover span,
.Pagination_menulinklight__sX78A:hover a {
  color: #fff !important;
}

.Pagination_menulinkdarkSelected__EVStZ {
  background-color: #1c2e45;
  color: #3b82f6;
}

.Pagination_menuthemelight__k4gQv .Pagination_menulinklightSelected__zrpEN {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.Pagination_menulinkdark__eL8OR {
  color: #92afd3 !important;
}

.Pagination_menulinklight__sX78A:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.Pagination_menulinklight__sX78A .Pagination_sub_arrow__lVVDH svg path {
  stroke: #CBCBCB !important;
}

.Pagination_menulinklight__sX78A:hover .Pagination_sub_arrow__lVVDH svg path {
  stroke: #fff !important;
}

.Pagination_menulinkdark__eL8OR .Pagination_sub_arrow__lVVDH svg path {
  stroke: #92afd3 !important;
}

.Pagination_menulinkdark__eL8OR:hover .Pagination_sub_arrow__lVVDH svg path {
  stroke: #fff !important;
}

.Pagination_menulinklight__sX78A:hover svg path,
.Pagination_menulinklightSelected__zrpEN svg path {
  fill: #fff !important;
}

.Pagination_menulinkdark__eL8OR:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.Pagination_headinglight__35cyh {
  color: #60677e;
}

.Pagination_headingdark__36KvX {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.Pagination_searchboxlight__s\\+wm4 {
  background-color: #fff;
  border: none;
}

.Pagination_searchboxdark__0RZjp {
  background-color: #132337;
  color: #fff;
  border: none;
}

.Pagination_searchboxdark__0RZjp::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.Pagination_tableheadlight__BaqoI {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.Pagination_tableheadlight__BaqoI th {
  color: #fff;
}

thead .Pagination_tableheadlight__BaqoI th:first-child,
thead .Pagination_tableheaddark__5KsVI th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .Pagination_tableheadlight__BaqoI th:last-child,
thead .Pagination_tableheaddark__5KsVI th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.Pagination_table__y5zmQ.Pagination_table-borderless__xibJL {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.Pagination_tableheaddark__5KsVI {
  background-color: #132337;
  color: #fff;
}

.Pagination_table-borderless__xibJL tr:nth-child(even) {
  background-color: #F9FAFB;
}

.Pagination_table-borderless__xibJL .Pagination_left-section__hQaak {
  padding-top: 10px;
}

.Pagination_tablebodylight__E3aoH td,
.Pagination_tablebodydark__Bb46b td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.Pagination_tablebodylight__E3aoH {
  background-color: #fff;
}
.Pagination_tablebodylight__E3aoH:hover {
  background-color: #fff;
  cursor: auto;
}

.Pagination_tablebodydark__Bb46b {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.Pagination_tablebodydark__Bb46b:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.Pagination_paginationlight__1TgmT {
  color: #60677e !important;
  font-size: 13px !important;
}

.Pagination_paginationdark__AEqE5 {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.Pagination_formthemelight__zzVIW {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.Pagination_formthemedark__E4MYO {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.Pagination_formthemedark__E4MYO ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.Pagination_viewformlight__fVh6N {
  background-color: #f3f6f9;
}

.Pagination_permissionboxlight__lbbP- {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.Pagination_permissionboxdark__yFS4k {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.Pagination_errormsgclr__VLqeq {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.Pagination_graphclrlight__1ZNHL {
  background-color: #fff;
}

.Pagination_graphclrdark__UXGf8 {
  background-color: #132337;
}

/* 
Counter theme
*/
#Pagination_card1bglight__Olemd {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#Pagination_card1bgdark__OdKzz {
  background: #392f28;
}

#Pagination_card2bglight__Wpqrw {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#Pagination_card2bgdark__sjBGc {
  background: #1c3238;
}

#Pagination_card3bglight__EeWN- {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#Pagination_card3bgdark__JuixI {
  background: #3a2434;
}

#Pagination_card4bglight__Uqrm4 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#Pagination_card4bgdark__OEsuw {
  background: #2f264f;
}

#Pagination_card1bgdark__OdKzz a,
#Pagination_card1bgdark__OdKzz p,
#Pagination_card2bgdark__sjBGc a,
#Pagination_card2bgdark__sjBGc p,
#Pagination_card3bgdark__JuixI a,
#Pagination_card3bgdark__JuixI p,
#Pagination_card4bgdark__OEsuw a,
#Pagination_card4bgdark__OEsuw p {
  color: #fff;
}

/* 
Action button theme
*/
.Pagination_actionbtnlight__ynj7y {
  color: rgba(70, 71, 91, 0.8705882353);
}

.Pagination_actionbtndark__HO3Fe {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.Pagination_profiledropdownlight__fmco2 {
  background-color: #fff;
}

.Pagination_profiledropdowndark__7OCJb {
  background-color: #151521;
}

.Pagination_settingsection__rvauY #Pagination_addform__XTerP.Pagination_formthemedark__E4MYO .Pagination_savebtn__JqaFq {
  background-color: #3b82f6;
  color: #fff;
}

#Pagination_addform__XTerP.Pagination_formthemedark__E4MYO .Pagination_savebtn__JqaFq {
  background-color: #3b82f6;
  color: #fff;
}

.Pagination_profile_conatiner__rupz3 {
  border-radius: 5px !important;
}

.Pagination_bodythemedark__OgYY8 .Pagination_ag-theme-alpine__47q7Y .Pagination_ag-row__nwqt5 {
  background: #000 !important;
}

.Pagination_bodythemedark__OgYY8 .Pagination_formbtn__RbqfV {
  background-color: #3b82f6;
}

.Pagination_bodythemedark__OgYY8 .Pagination_formbtn__RbqfV:hover {
  background-color: #2563eb;
}

.Pagination_bodythemedark__OgYY8 .Pagination_resetbtn__xXX2V {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.Pagination_headingdark__36KvX span {
  background-color: #132337;
}

.Pagination_resetbtn__xXX2V {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.Pagination_resetbtn__xXX2V:hover,
.Pagination_resetbtn__xXX2V:active,
.Pagination_resetbtn__xXX2V:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.Pagination_addBtn__\\+WUXn {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.Pagination_addDltBtn__AXGDA {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.Pagination_addbtnlight__QNxNJ {
  background-color: #38A169;
}

.Pagination_addbtndark__d2DZB {
  background-color: #3b82f6;
}

.Pagination_addbtndark__d2DZB:hover {
  background-color: #2563eb;
}

.Pagination_formthemedark__E4MYO label {
  color: #92afd3;
}

.Pagination_addBtn__\\+WUXn svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.Pagination_addBtn__\\+WUXn:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.Pagination_cust_addBtn__fL0mq.Pagination_addBtn__\\+WUXn svg {
  top: 2px;
}

.Pagination_deleteBtn__m2QAL {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.Pagination_deleteBtn__m2QAL:active,
.Pagination_deleteBtn__m2QAL:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.Pagination_deleteBtn__m2QAL svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.Pagination_deleteBtn__m2QAL:hover,
.Pagination_deleteBtn__m2QAL:active,
.Pagination_deleteBtn__m2QAL:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.Pagination_confirmBtn__kkMo9 {
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  background-color: #131F43 !important;
}

.Pagination_confirmBtn__kkMo9:active,
.Pagination_confirmBtn__kkMo9:focus {
  background-color: #131F43 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.Pagination_confirmBtn__kkMo9:hover,
.Pagination_confirmBtn__kkMo9:active,
.Pagination_confirmBtn__kkMo9:focus {
  background-color: #0f1824 !important;
}

.Pagination_confirmBtn__kkMo9 svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.Pagination_delPopContainer__Oj84z .Pagination_modal-body__w9Cdn {
  padding: 35px;
  text-align: center;
}

.Pagination_delPopContainer__Oj84z .Pagination_delet_icon__BmG-y {
  margin-bottom: 11px;
}

.Pagination_delPopContainer__Oj84z p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.Pagination_arrowback__12gk0 svg {
  fill: #000;
}

.Pagination_bodythemedark__OgYY8 .Pagination_arrowback__12gk0 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.Pagination_bodythemedark__OgYY8 .Pagination_arrowback__12gk0 svg {
  fill: #3b82f6;
}

.Pagination_bodythemedark__OgYY8 .Pagination_drpdwn_btn__0KUs7 {
  background-color: #132337;
}

.Pagination_bodythemedark__OgYY8 .Pagination_empname__9jb80 {
  color: #92afd3 !important;
}

.Pagination_bodythemedark__OgYY8 .Pagination_navitemli__SgTIi a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.Pagination_bodythemedark__OgYY8 .Pagination_tabnavli__3aDRL a.Pagination_settingsgeneral__Nxyzg,
.Pagination_bodythemedark__OgYY8 .Pagination_tabnavli__3aDRL a.Pagination_settingslinks__Fsoxr:hover {
  background-color: #3b82f6;
  color: #fff;
}

.Pagination_bodythemedark__OgYY8 .Pagination_tabnavli__3aDRL a.Pagination_settingslinks__Fsoxr {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.Pagination_headerthemedark__r4EaC .Pagination_dropdown_menu_contain__XzqCH {
  background-color: #1c2e45;
  color: #fff;
}

.Pagination_headerthemedark__r4EaC .Pagination_dropdown_menu_contain__XzqCH ul li a,
.Pagination_headerthemedark__r4EaC .Pagination_dropdown_menu_contain__XzqCH .Pagination_dropdown_item__ur5Ww,
.Pagination_headerthemedark__r4EaC .Pagination_dropdown_menu_contain__XzqCH .Pagination_dropdown_item__ur5Ww h5 {
  color: #fff;
}

.Pagination_headerthemedark__r4EaC .Pagination_dropdown_menu_contain__XzqCH ul li a:hover,
.Pagination_headerthemedark__r4EaC .Pagination_dropdown_menu_contain__XzqCH .Pagination_dropdown_item__ur5Ww:hover {
  background-color: #132337;
  color: #fff;
}

.Pagination_dropdown_item__ur5Ww:active {
  background-color: #F5F6FA;
}

.Pagination_profile_arrrow_dwn__YcNXw {
  stroke: #132337;
}

.Pagination_headerthemedark__r4EaC .Pagination_profile_arrrow_dwn__YcNXw {
  stroke: #fff;
}

.Pagination_dateinputbox1__BKBu0 input,
.Pagination_dateinputbox1__BKBu0 span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.Pagination_delPopContainer__Oj84z .Pagination_modal-content__SNELE {
  border-radius: 10px;
  min-width: 399px;
}

.Pagination_larg_model__szvQz .Pagination_modal-dialog__0DqCk {
  max-width: 100% !important;
}

.Pagination_larg_model__szvQz .Pagination_modal-content__SNELE {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.Pagination_larg_model__szvQz .Pagination_modal-header__X4FDv {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .Pagination_btn-primary__mnYEd:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.Pagination_form-select__ZZaBk {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .Pagination_CustomTable_tableheadlight__HuHZw__YIjmn th:first-child,
thead .Pagination_CustomTable_tableheaddark__nwqb4__Jsrb\\+ th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
}

@media only screen and (max-width: 1200px) {
  .Pagination_tableheadlight__BaqoI th {
    min-width: 170px;
  }
}
@media only screen and (max-width: 1024px) {
  .Pagination_dashboard__kQixg {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden;
  }
  .Pagination_cont2__SZIEC {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
  /*.tableheadlight th {
    min-width: 200px !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .Pagination_sectionright__Ezc2w {
    float: unset !important;
  }
  .Pagination_formthemelight__zzVIW {
    padding: 10px 0 !important;
    box-shadow: none !important;
  }
  .Pagination_dashboard__kQixg {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .Pagination_cont2__SZIEC {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .Pagination_bodythemelight__R2JcG,
.Pagination_bodythemedark__OgYY8 {
    padding-top: 110px;
  }
  .Pagination_delPopContainer__Oj84z .Pagination_modal-content__SNELE {
    min-width: 100%;
  }
  .Pagination_delPopContainer__Oj84z .Pagination_modal-body__w9Cdn {
    padding: 15px;
  }
  .Pagination_larg_model__szvQz .Pagination_modal-content__SNELE {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .Pagination_exer_modal_contain__bVktO .Pagination_modal-dialog__0DqCk {
    max-width: 1055px;
  }
  .Pagination_delPopContainer__Oj84z .Pagination_modal-dialog__0DqCk {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 200px;
  }*/
}
/* vk new changes */
.Pagination_active_show_outer__Wb6Qc h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: "Plus Jakarta Sans", "Lufga", sans-serif !important;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm {
  width: 100%;
  display: block;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_img__Eddye {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_img__Eddye {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_img__Eddye img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_cnt__Kzf69 {
  width: 100%;
  display: block;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_cnt__Kzf69 svg {
  flex-shrink: 0;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_cnt__Kzf69 .Pagination_act_box_bdg__y-hW5 {
  width: 100%;
  margin-bottom: 12px;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_cnt__Kzf69 .Pagination_act_box_bdg__y-hW5 span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_cnt__Kzf69 .Pagination_act_box_bdg__y-hW5 .Pagination_sold__TpiZ2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_cnt__Kzf69 h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_cnt__Kzf69 p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.Pagination_active_show_outer__Wb6Qc .Pagination_active_show_inner__b0ocm .Pagination_act_box_cnt__Kzf69 p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}

/* vk new changes */
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_l__-yHre img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: contain;
}
@media screen and (max-width: 767px) {
  .Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_l__-yHre img {
    object-fit: contain;
    width: auto;
  }
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 {
  flex: 1 1;
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row__1DAxv {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row__1DAxv {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row__1DAxv .Pagination_attent_details_row_box__6CrqC {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row__1DAxv .Pagination_attent_details_row_box__6CrqC {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row__1DAxv .Pagination_attent_details_row_box__6CrqC {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row__1DAxv .Pagination_attent_details_row_box__6CrqC p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row__1DAxv .Pagination_attent_details_row_box__6CrqC h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row_last__T-LxK {
  margin-bottom: 0px !important;
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row_last__T-LxK.Pagination_interesting_fact__9CM5p {
  padding-top: 30px;
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row_last__T-LxK.Pagination_interesting_fact__9CM5p .Pagination_attent_details_row_box__6CrqC {
  width: 100%;
}
.Pagination_attent_details__IvL4J .Pagination_attent_details_inner__vs9YP .Pagination_attent_details_inner_r__BTOR0 .Pagination_attent_details_row_last__T-LxK.Pagination_interesting_fact__9CM5p .Pagination_attent_details_row_box__6CrqC h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.Pagination_showbox_sec__1M1wo {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  align-items: stretch;
  width: 100%;
}
@media screen and (max-width: 500px) {
  .Pagination_showbox_sec__1M1wo {
    grid-template-columns: 1fr;
  }
}

.Pagination_show_box_main__K\\+oVW {
  margin: 10px 0px;
  width: 100%;
}
.Pagination_show_box_main__K\\+oVW .Pagination_show_box__NjU3V {
  min-height: 600px;
  width: 100%;
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .Pagination_show_box_main__K\\+oVW .Pagination_show_box__NjU3V {
    min-height: 500px;
  }
}
.Pagination_show_box_main__K\\+oVW .Pagination_show_box__NjU3V .Pagination_active_show_inner__b0ocm {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.Pagination_show_box_main__K\\+oVW .Pagination_show_box__NjU3V .Pagination_act_box_img__Eddye {
  flex-shrink: 0;
}
.Pagination_show_box_main__K\\+oVW .Pagination_show_box__NjU3V .Pagination_act_box_cnt__Kzf69 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.Pagination_show_box_main__K\\+oVW .Pagination_show_box__NjU3V img {
  max-height: 400px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 767px) {
  .Pagination_show_box_main__K\\+oVW .Pagination_show_box__NjU3V img {
    max-height: 300px !important;
  }
}
.Pagination_show_box_main__K\\+oVW .Pagination_show_box__NjU3V:last-child {
  margin-right: 0;
}
.Pagination_show_box_main__K\\+oVW .Pagination_no_show_box__TTkk0 {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .Pagination_show_box_main__K\\+oVW .Pagination_no_show_box__TTkk0 {
    width: 250px !important;
  }
}
.Pagination_show_box_main__K\\+oVW .Pagination_no_show_box__TTkk0 img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .Pagination_show_box_main__K\\+oVW .Pagination_no_show_box__TTkk0 img {
    max-height: 350px !important;
  }
}
.Pagination_show_box_main__K\\+oVW .Pagination_no_show_box__TTkk0 h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .Pagination_show_box_main__K\\+oVW .Pagination_no_show_box__TTkk0 h6 {
    font-size: 20px;
  }
}

.Pagination_attent_flex__oELv1 {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.Pagination_attent_flex__oELv1 h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.Pagination_paginationright__cXPdT {
  float: right;
  margin-right: 15px;
}
.Pagination_paginationright__cXPdT #Pagination_pagetext__NdLdG {
  font-size: 12px;
}
.Pagination_paginationright__cXPdT #Pagination_pagebtn__5LODQ {
  background: none;
  border: none;
  width: 25px;
  height: 25px;
  margin-top: 5px;
}

.Pagination_paginations_bg__zVk6n {
  background-color: #fff;
  padding: 22px 20px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
@media screen and (max-width: 768px) {
  .Pagination_paginations_bg__zVk6n {
    padding: 15px;
  }
}
.Pagination_paginations_bg__zVk6n .Pagination_pageof__o-11s {
  left: 20px;
  top: 28px;
  font-size: 16px;
  color: #1d1d1d;
}
@media screen and (max-width: 767px) {
  .Pagination_paginations_bg__zVk6n .Pagination_pageof__o-11s {
    position: absolute;
  }
}
.Pagination_paginations_bg__zVk6n .Pagination_total_users__Awa0w {
  right: 20px;
  top: 28px;
  font-size: 16px;
  color: #1d1d1d;
}
@media screen and (max-width: 768px) {
  .Pagination_paginations_bg__zVk6n .Pagination_total_users__Awa0w {
    top: 16px;
  }
}
@media screen and (max-width: 767px) {
  .Pagination_paginations_bg__zVk6n .Pagination_total_users__Awa0w {
    position: absolute;
  }
}
.Pagination_paginations_bg__zVk6n .Pagination_paginationm_container__hfKJW {
  margin: 0;
  gap: 5px;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
@media screen and (max-width: 767px) {
  .Pagination_paginations_bg__zVk6n .Pagination_paginationm_container__hfKJW {
    padding-bottom: 10px;
  }
}
.Pagination_paginations_bg__zVk6n .Pagination_paginationm_container__hfKJW a {
  background-color: transparent;
  border: none;
  font-weight: 500;
  font-size: 14px;
  padding: 6px 14px;
  color: #1d1d1d;
  border-radius: 5px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Pagination_paginations_bg__zVk6n .Pagination_paginationm_container__hfKJW a:hover {
  border-radius: 5px;
  background-color: #131F43;
  color: #fff;
}
.Pagination_paginations_bg__zVk6n .Pagination_paginationm_container__hfKJW .Pagination_active__q3h4d {
  background-color: #131F43;
  border-radius: 5px;
}
.Pagination_paginations_bg__zVk6n .Pagination_paginationm_container__hfKJW .Pagination_active__q3h4d a {
  color: #fff;
}
.Pagination_paginations_bg__zVk6n .Pagination_paginationm_container__hfKJW .Pagination_pagination_next__HgofK a {
  font-weight: 600;
  cursor: pointer;
}

.Pagination_bodythemedark__OgYY8.Pagination_paginations_bg__zVk6n {
  background-color: #132337;
}
.Pagination_bodythemedark__OgYY8.Pagination_paginations_bg__zVk6n ul li.Pagination_active__q3h4d {
  background-color: #0f1824;
}
.Pagination_bodythemedark__OgYY8.Pagination_paginations_bg__zVk6n ul li a {
  color: #fff;
}
.Pagination_bodythemedark__OgYY8.Pagination_paginations_bg__zVk6n ul li a:hover {
  border-radius: 5px;
  background-color: #0f1824;
  color: #fff;
}
.Pagination_bodythemedark__OgYY8.Pagination_paginations_bg__zVk6n .Pagination_pageof__o-11s {
  color: #fff;
}

/* ✅ Tablet responsive */
@media only screen and (max-width: 998px) {
  .Pagination_paginations_bg__zVk6n {
    justify-content: space-between;
    align-items: center;
  }
  .Pagination_paginationm_container__hfKJW {
    margin: auto;
    width: auto;
    max-width: 100%;
  }
  .Pagination_paginations_bg__zVk6n .Pagination_pageof__o-11s {
    position: unset;
    margin-bottom: 0px;
  }
  .Pagination_pagination__mVvOv {
    display: flex;
    padding-left: 0;
    list-style: none;
    justify-content: center;
    overflow-x: auto;
    overflow-y: hidden;
  }
}
/* ✅ Mobile responsive */
@media only screen and (max-width: 767px) {
  .Pagination_paginations_bg__zVk6n {
    flex-direction: column;
  }
  .Pagination_paginations_bg__zVk6n .Pagination_total_users__Awa0w {
    position: relative;
    right: 0;
    top: 0;
    font-size: 16px;
    color: #1d1d1d;
    text-align: center;
    padding: 10px 0px;
  }
  .Pagination_paginations_bg__zVk6n .Pagination_pageof__o-11s {
    text-align: center;
    margin-bottom: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Pagination/Pagination.module.scss","webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAmDC;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,gBAAA;ADvEH;;AC0EC;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ADvEH;;AC0EC;;;EAGE,yBAnEoB;ADJvB;;AC0EC;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ADvEH;;AC0EC;;CAAA;AAIA;EACE,wBAzCU;EA0CV,UAzCS;EA0CT,kBAAA;EACA,aAjDiB;EAkDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ADrEH;;AC2EC;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADxEH;;AC6EC;EACE,2BAAA;AD1EH;;AC6EC;EACE,yBAAA;EACA,YAAA;AD1EH;;AC8EC;EACE,YAAA;AD3EH;;AC8EC;EACE,sBA9GY;ADmCf;;AC8EC;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AD3EH;;AC8EC;EACE,yBArIgB;EAsIhB,iBAAA;AD3EH;;AC8EC;;CAAA;AAGA;EACE,sBAlIY;ADuDf;;AC8EC;EACE,yBAjJgB;ADsEnB;;AC8EC;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AD3EH;;AC8EC;;CAAA;AAGA;EACE,sBAvJY;AD4Ef;;AC8EC;EACE,yBAtKgB;AD2FnB;;AC8EC;;CAAA;AAGA;EACE,yBAAA;AD3EH;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;;EAEE,sBAAA;AD3EH;;AC8EC;EACE,yBAxLsB;EAyLtB,cAnMkB;ADwHrB;;AC8EC;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AD3EH;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;EACE,sBAAA;EACA,oCAAA;AD3EH;;AC8EC;EACE,0BAAA;AD3EH;;AC8EC;EACE,uBAAA;AD3EH;;AC8EC;EACE,0BAAA;AD3EH;;AC8EC;EACE,uBAAA;AD3EH;;AC8EC;;EAEE,qBAAA;AD3EH;;AC8EC;EACE,yBAjOsB;EAkOtB,WAzNY;AD8If;;AC8EC;;CAAA;AAGA;EACE,cA7Ne;ADkJlB;;AC8EC;EACE,cAjOe;ADsJlB;;AC8EC;;CAAA;AAGA;EACE,sBA3OY;EA4OZ,YAAA;AD3EH;;AC8EC;EACE,yBA3PgB;EA4PhB,WAjPY;EAkPZ,YAAA;AD3EH;;AC8EC;EACE,cAnPe;ADwKlB;;AC8EC;;CAAA;AAGA;EACE,yBA3Sc;EA4Sd,8BAAA;AD3EH;;AC8EC;EACE,WAlQY;ADuLf;;AC8EC;;EAEE,0BAAA;AD3EH;;AC8EC;;EAEE,0BAAA;AD3EH;;AC8EC;EACE,kBAAA;AD3EH;;AC8EC;EACE,kBAAA;AD3EH;;AC8EC;EACE,oCAAA;EACA,gCAAA;AD3EH;;AC8EC;EACE,yBArRkB;EAsRlB,WA9RY;ADmNf;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;EACE,iBAAA;AD3EH;;AC8EC;;EAEE,+BAAA;EACA,iBAAA;AD3EH;;AC8EC;EACE,sBAhTY;ADqOf;AC6EG;EACE,sBAnTU;EAoTV,YAAA;AD3EL;;AC+EC;EACE,0CAAA;EACA,cAvTe;AD2OlB;AC8EG;EACE,yCAAA;EACA,eAAA;AD5EL;;ACgFC;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AD7EH;;ACgFC;EACE,yBAAA;EACA,0BAAA;AD7EH;;ACgFC;;CAAA;AAGA;EACE,sBAnVY;EAoVZ,yBAAA;EACA,qDAAA;AD7EH;;ACgFC;EACE,yBAjVkB;EAkVlB,yBAAA;EACA,eAAA;AD7EH;AC+EG;EACE,cA3Va;AD8QlB;;ACkFC;;CAAA;AAGA;EACE,yBA1WgB;AD2RnB;;ACkFC;EACE,yBAAA;EACA,yBAAA;AD/EH;;ACkFC;EACE,yBA1XoB;EA2XpB,yBAAA;AD/EH;;ACkFC;EACE,UAAA;EACA,eAAA;EACA,eAAA;AD/EH;;ACkFC;;CAAA;AAGA;EACE,sBA9XY;AD+Sf;;ACkFC;EACE,yBA1XkB;AD2SrB;;ACmFC;;CAAA;AAGA;EACE,iGAAA;EACA,sBA3YY;AD2Tf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBApZY;ADoUf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBA7ZY;AD6Uf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBAtaY;ADsVf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;;;;;;;;EAQE,WArbY;ADqWf;;ACmFC;;CAAA;AAGA;EACE,qCAAA;ADhFH;;ACmFC;EACE,cA7be;AD6WlB;;ACoFC;;CAAA;AAGA;EACE,sBAAA;ADjFH;;ACoFC;EACE,yBAAA;ADjFH;;ACoFC;EACE,yBAjekB;EAkelB,WAjdY;ADgYf;;ACoFC;EACE,yBAtekB;EAuelB,WAtdY;ADqYf;;ACoFC;EACE,6BAAA;ADjFH;;ACoFC;EACE,2BAAA;ADjFH;;ACoFC;EACE,yBAnfkB;ADkarB;;ACoFC;EACE,yBAtfwB;ADqa3B;;ACoFC;EACE,WA1eY;EA2eZ,6BAAA;EACA,yBAAA;ADjFH;;ACqFC;EACE,yBA5fgB;AD0anB;;ACqFC;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ADlFH;;ACqFC;;;EAGE,oCAAA;EACA,sBAAA;ADlFH;;ACqFC;EACE,gBAAA;EACA,YAAA;EACA,WAxgBY;EAygBZ,yBAriBY;EAsiBZ,YAAA;EACA,eAAA;EACA,gBAhkBc;AD8ejB;;ACqFE;EACC,gBAAA;EACA,YAAA;EACA,WAlhBY;EAmhBZ,yBA/iBY;EAgjBZ,YAAA;EACA,eAAA;EACA,gBA1kBc;ADwfjB;;ACqFC;EACE,yBAtjBY;ADoef;;ACqFC;EACE,yBA/iBkB;AD6drB;;ACqFC;EACE,yBAljBwB;ADge3B;;ACqFC;EACE,cAxjBiB;ADsepB;;ACsFC;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ADnFH;;ACsFC;EACE,WAjjBY;EAkjBZ,yBA9kBY;EA+kBZ,YAAA;ADnFH;;ACsFC;EACE,QAAA;ADnFH;;ACuFC;EACE,gBAAA;EACA,YAAA;EACA,yBAnlBW;EAolBX,WA/jBY;EAgkBZ,eAAA;EACA,gBArnBc;EAsnBd,YAAA;ADpFH;;ACuFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADpFH;;ACuFC;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADpFH;;ACuFC;;;EAGE,yBA1mBW;EA2mBX,WAtlBY;EAulBZ,YAAA;ADpFH;;ACuFC;EACC,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,oCAAA;ADpFF;;ACuFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADpFH;;ACuFC;;;EAGE,oCAAA;ADpFH;;ACuFC;EACC,kBAAA;EACA,kBAAA;EACA,SAAA;ADpFF;;ACyFC;EACE,aAAA;EACA,kBAAA;ADtFH;;ACyFC;EACE,mBAAA;ADtFH;;ACyFC;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ADtFH;;ACyFC;EACE,UAAA;ADtFH;;ACyFC;EACE,yCA7pBc;EA8pBd,cAlqBkB;AD4kBrB;;ACyFC;EACE,aAtqBkB;ADglBrB;;ACyFC;EACE,yBAlqBgB;AD4kBnB;;ACyFC;EACE,yBAAA;ADtFH;;ACyFC;EACE,6BAAA;EACA,yBAAA;EACA,WAjqBY;AD2kBf;;ACyFC;;EAEE,yBAvrBkB;EAwrBlB,WAvqBY;ADilBf;;ACyFC;EACE,6BAAA;EACA,yBAAA;EACA,WA7qBY;ADulBf;;ACyFC;EACE,yBA1rBsB;EA2rBtB,WAlrBY;AD4lBf;;ACyFC;;;EAGE,WAxrBY;ADkmBf;;ACyFC;;EAEE,yBAxsBgB;EAysBhB,WA9rBY;ADwmBf;;ACyFC;EACE,yBAjvBO;AD2pBV;;ACyFC;EACE,eAjtBgB;AD2nBnB;;ACyFC;EACE,YA1sBY;ADonBf;;ACyFC;;EAEE,sBAAA;ADtFH;;ACyFC,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AD1FH;;AC6FC;EACE,0BAAA;AD1FH;;AC6FC;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AD1FH;;AC6FC;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AD1FH;;AC6FC;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AD1FH;;AC6FC;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AD1FH;;AC6FC;;EAEE,0BAAA;EACA,aAAA;AD1FH;;AC6FC;EACE,kBAAA;AD1FH;;AC6FC;EACE;IACE,gBAAA;ED1FH;AACF;AC6FC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kBAAA;ED3FH;EC8FC;IACE,2BAAA;IACA,gBAAA;ED5FH;AACF;AC+FC;EACE;;IAAA;EAGA;;IAAA;AD3FH;ACgGC;EACE;IACE,uBAAA;ED9FH;ECgGD;IACE,0BAAA;IACA,2BAAA;ED9FD;ECgGC;IACE,6BAAA;ED9FH;AACF;ACiGC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;ED/FH;ECkGC;;IAEE,kBAAA;EDhGH;ECmGC;IACE,eAAA;EDjGH;ECoGC;IACE,aAAA;EDlGH;ECqGC;IACE,8BAAA;IACA,aAAA;EDnGH;AACF;ACsGC;EACE;IACE,iBAAA;EDpGH;ECuGC;IACE,gBAAA;EDrGH;ECwGC;;IAAA;ADpGH;ACyGC,mBAAA;AAGA;EACE,iCAAA;EACA,gEAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADzGH;AC4GG;EACE,WAAA;EACA,cAAA;AD1GL;AC4GK;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AD1GP;AC2GO;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;EDxGP;AACF;ACyGO;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ADvGT;AC2GK;EACE,WAAA;EACA,cAAA;ADzGP;AC0GC;EACC,cAAA;ADxGF;AC0GO;EACE,WAAA;EACA,mBAAA;ADxGT;AC0GS;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADxGX;AC2GS;EACE,kFAAA;ADzGX;AC8GO;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AD5GT;AC+GO;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AD7GT;AC+GS;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AD7GX;;ACoHC,mBAAA;AAEE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ADlHL;ACoHK;EATF;IAUI,yBAAA;EDjHL;AACF;ACmHK;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EDhHL;AACF;ACmHO;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;ADjHT;ACkHS;EALF;IAMG,mBAAA;IACA,WAAA;ED/GR;AACF;ACmHK;EACE,SAAA;ADjHP;ACmHO;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ADjHT;ACmHS;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;EDhHT;AACF;ACkHS;EACE,SAAA;EACA,UAAA;ADhHX;ACkHW;EAJF;IAKI,gCAAA;IACA,sBAAA;ED/GX;AACF;ACiHW;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;ED9GX;AACF;ACgHW;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD9Gb;ACiHW;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AD/Gb;ACoHM;EACE,6BAAA;ADlHR;ACmHQ;EACE,iBAAA;ADjHV;ACkHU;EACE,WAAA;ADhHZ;ACiHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AD/Gd;;ACuHC;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;ADpHH;ACqHG;EANF;IAOI,0BAAA;EDlHH;AACF;;ACoHC;EACE,gBAAA;EACA,WAAA;ADjHH;ACmHG;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;ADjHL;ACmHK;EATF;IAUI,iBAAA;EDhHL;AACF;ACkHK;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ADhHP;ACmHK;EACE,cAAA;ADjHP;ACoHK;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;ADlHP;ACqHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ADnHP;ACqHO;EANF;IAOI,4BAAA;EDlHP;AACF;ACqHK;EACE,eAAA;ADnHP;ACuHG;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ADrHL;ACuHK;EALF;IAMI,uBAAA;EDpHL;AACF;ACsHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ADpHP;ACsHO;EALF;IAMI,4BAAA;EDnHP;AACF;ACqHK;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ADnHP;ACoHO;EARF;IASI,eAAA;EDjHP;AACF;;ACwHC;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ADrHH;ACuHG;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ADrHL;;AAjlCA;EACI,YAAA;EACA,kBAAA;AAolCJ;AAllCI;EACI,eAAA;AAolCR;AAjlCI;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAmlCR;;AA/kCA;EACI,sBCqCW;EDpCX,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAklCJ;AAhlCI;EATJ;IAUQ,aAAA;EAmlCN;AACF;AAjlCI;EACI,UAAA;EACA,SAAA;EACA,eAAA;EACA,cCuBW;AD4jCnB;AAllCQ;EALJ;IAMQ,kBAAA;EAqlCV;AACF;AAllCI;EACI,WAAA;EACA,SAAA;EACA,eAAA;EACA,cCaW;ADukCnB;AAllCQ;EANJ;IAOQ,SAAA;EAqlCV;AACF;AAnlCQ;EAVJ;IAWO,kBAAA;EAslCT;AACF;AAnlCI;EACI,SAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AAqlCR;AAplCQ;EARJ;IASO,oBAAA;EAulCT;AACF;AArlCQ;EACI,6BAAA;EACA,YAAA;EACA,gBCpEG;EDqEH,eAAA;EACA,iBAAA;EACA,cChBO;EDiBP,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAulCZ;AArlCY;EACI,kBAAA;EACA,yBCzEC;ED0ED,WC5BD;ADmnCf;AAnlCQ;EACI,yBC/EK;EDgFL,kBAAA;AAqlCZ;AAnlCY;EACI,WCrCD;AD0nCf;AAhlCY;EACI,gBC/FC;EDgGD,eAAA;AAklChB;;AA5kCA;EACI,yBC9De;AD6oCnB;AA3kCY;EACI,yBClEO;AD+oCvB;AA1kCY;EACI,WC5DD;ADwoCf;AA1kCgB;EACI,kBAAA;EACA,yBC1EG;ED2EH,WCjEL;AD6oCf;AAtkCI;EACI,WCxEO;ADgpCf;;AApkCA,wBAAA;AACA;EACI;IACI,8BAAA;IACA,mBAAA;EAukCN;EApkCE;IACI,YAAA;IACA,WAAA;IACA,eAAA;EAskCN;EAnkCE;IACI,eAAA;IACA,kBAAA;EAqkCN;EAlkCE;IACI,aAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,kBAAA;EAokCN;AACF;AAjkCA,wBAAA;AACA;EACI;IACI,sBAAA;EAmkCN;EAhkCE;IACI,kBAAA;IACA,QAAA;IACA,MAAA;IACA,eAAA;IACA,cAAA;IACA,kBAAA;IACA,iBAAA;EAkkCN;EA/jCE;IACI,kBAAA;IACA,mBAAA;EAikCN;AACF","sourcesContent":["@import \"/src/styles/Variables/Variables.scss\";\n\n.paginationright {\n    float: right;\n    margin-right: 15px;\n\n    #pagetext {\n        font-size: 12px;\n    }\n\n    #pagebtn {\n        background: none;\n        border: none;\n        width: 25px;\n        height: 25px;\n        margin-top: 5px;\n    }\n}\n\n.paginations_bg {\n    background-color: $white-color;\n    padding: 22px 20px;\n    border-radius: 5px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n\n    @media screen and (max-width:768px) {\n        padding: 15px;\n    }\n\n    .pageof {\n        left: 20px;\n        top: 28px;\n        font-size: 16px;\n        color: $fullBlack-color;\n        @media screen and (max-width:767px) {\n            position: absolute;\n        }\n    }\n\n    .total_users {\n        right: 20px;\n        top: 28px;\n        font-size: 16px;\n        color: $fullBlack-color;\n\n        @media screen and (max-width:768px) {\n            top: 16px;\n        }\n\n        @media screen and (max-width:767px) {\n           position: absolute;\n        }\n    }\n\n    .paginationm_container {\n        margin: 0;\n        gap: 5px;\n        display: flex;\n        align-items: center;\n        overflow-x: auto;    // ✅ only horizontal scroll\n        overflow-y: hidden;\n        -webkit-overflow-scrolling: touch; // smooth scroll in mobile\n        @media screen and (max-width:767px) {\n           padding-bottom: 10px;\n        }\n\n        a {\n            background-color: transparent;\n            border: none;\n            font-weight: $font-medium;\n            font-size: 14px;\n            padding: 6px 14px;\n            color: $fullBlack-color;\n            border-radius: 5px;\n            height: 36px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            &:hover {\n                border-radius: 5px;\n                background-color: $primary-color;\n                color: $white-color;\n            }\n        }\n\n        .active {\n            background-color: $primary-color;\n            border-radius: 5px;\n\n            a {\n                color: $white-color;\n            }\n        }\n\n        .pagination_next {\n            a {\n                font-weight: $font-semiBold;\n                cursor: pointer;\n            }\n        }\n    }\n}\n\n.bodythemedark.paginations_bg {\n    background-color: $darkTheme_blue;\n\n    ul {\n        li {\n            &.active {\n                background-color: $darkTheme_darkBlue;\n            }\n\n            a {\n                color: $white-color;\n\n                &:hover {\n                    border-radius: 5px;\n                    background-color: $darkTheme_darkBlue;\n                    color: $white-color;\n                }\n            }\n        }\n    }\n\n    .pageof {\n        color: $white-color;\n    }\n}\n\n/* ✅ Tablet responsive */\n@media only screen and (max-width: 998px) {\n    .paginations_bg {\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .paginationm_container {\n        margin: auto;\n        width: auto;     // ✅ no fixed 330px\n        max-width: 100%; // fits inside parent\n    }\n\n    .paginations_bg .pageof {\n        position: unset;\n        margin-bottom: 0px;\n    }\n\n    .pagination {\n        display: flex;\n        padding-left: 0;\n        list-style: none;\n        justify-content: center;\n        overflow-x: auto;   // ✅ horizontal scroll only\n        overflow-y: hidden;\n    }\n}\n\n/* ✅ Mobile responsive */\n@media only screen and (max-width: 767px) {\n    .paginations_bg {\n        flex-direction: column;\n    }\n\n    .paginations_bg .total_users {\n        position: relative;\n        right: 0;\n        top: 0;\n        font-size: 16px;\n        color: #1d1d1d;\n        text-align: center;\n        padding: 10px 0px;\n    }\n\n    .paginations_bg .pageof {\n        text-align: center;\n        margin-bottom: 10px;\n    }\n}\n","/* \nscss\n */\n $font-regular: 400;\n $font-medium: 500;\n $font-semiBold: 600;\n $font-bold: 700;\n $font-extraBold: 800;\n $font-black: 900;\n \n $mainBg: #F5F6FA;\n $primary-color: #131F43;\n $icon-bgcolor: #F6F6F6;\n $text-graycolor: #727272;\n $cardIcon1-bg: #F3F4F8;\n $cardIcon1-darkbg: #30231a;\n $cardIcon1-darkbg-icon: #9d785f;\n $cardIcon2-bg: #FAF4FB;\n $cardIcon2-darkbg: #13252a;\n $cardIcon2-darkbg-icon: #3b606a;\n $cardIcon3-bg: #FAF7F3;\n $cardIcon3-darkbg: #2c1a27;\n $cardIcon3-darkbg-icon: #6c4863;\n $cardIcon4-bg: #F5F9FC;\n $cardIcon4-darkbg: #241d3e;\n $cardIcon4-darkbg-icon: #5f538b;\n $cardIcon2-color: #AC44BB;\n $cardIcon3-color: #D69A5F;\n $cardIcon4-color: #176CA5;\n $green-color: #38A169;\n $darkGreen-color: #207a4a;\n $placeholder-color: #666666;\n $profile-dark-text: #181818;\n $heading : #0B0D0F;\n $light-gray : #999999;\n $menu_icon : #CBCBCB;\n $red-color : #F94747;\n $red-hover : #960101;\n $dark-active-blue : #3b82f6;\n $dark-light-blue : #92afd3;\n $addBtn-dark-blue : #3b82f6;\n $addBtn-dark-blue-hover : #2563eb;\n $backBtn-dark : #3b82f633;\n \n \n \n $darkTheme_blue : #132337;\n $darkTheme_darkBlue : #0f1824;\n $darkTheme_selectBlue : #1c2e45;\n $darkTheme_updateBtn : #0a2574;\n \n /* \n Body Theme Color\n  */\n $lightthemecolor: #f3f6f9;\n $darkthemecolor: #151521;\n \n $white-color: #fff;\n $black-color: #1d1d1d;\n $fullBlack-color: #1d1d1d;\n $lightthemetext: #60677e;\n \n /* \n Dark Theme Colors\n */\n $primarydark-color: #132337;\n \n /* \n Button Theme\n */\n $primary-btncolor: #131F43;\n $secondary-btncolor: rgba(37, 105, 109, 0.864);\n \n $tableheadlightbg: #e9eaf0;\n \n \n /* \n Max Dashboard scss\n */\n $dashboardwidth: calc(100% - 320px);\n $dashboardposition: absolute;\n $dashboardleft: 290px;\n $dashboardpadding: 30px;\n \n /* \n Min Dashboard scss\n */\n $dashwidth: calc(100% - 50px);\n $dashleft: 50px;\n \n /* \n Max Dashboard scss\n */\n \n .dashboard {\n   width: $dashboardwidth;\n   position: relative;\n   left: $dashboardleft;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   min-height: auto !important;\n   background-color: $mainBg;\n   overflow-y: auto;\n }\n \n .dashboardContain {\n   width: calc(100% - 320px);\n   background-Color: $mainBg;\n   border-radius: 8px;\n }\n \n .bodythemedark .dashboardContain,\n .bodythemedark .dashboard,\n .bodythemedark .cont2 {\n   background-Color: $darkTheme_darkBlue;\n }\n \n .top_header .top_header_inner {\n   background-color: transparent;\n   height: auto;\n   overflow-y: unset;\n }\n \n /* \n Min Dashboard scss\n */\n \n .cont2 {\n   width: $dashwidth;\n   left: $dashleft;\n   position: relative;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   background: $mainBg;\n   /*height: calc(100vh - 160px);*/\n   height: 100%;\n   min-height: auto !important;\n   overflow-y: auto;\n   /* \n background-Color: $dashboardbackgroundColor;\n   padding-bottom: 8%;\n */\n }\n \n .subLink svg {\n   position: relative;\n   top: -2px;\n   left: -7px;\n }\n \n \n \n .cst_vendr input {\n   min-height: 35px !important;\n }\n \n .cst_vendr .form-control {\n   background-color: #f5f6fa;\n   border: none;\n }\n \n \n .footer {\n   height: 70px;\n }\n \n body {\n   background-color: $white-color;\n }\n \n /* \n THEME CHANGE\n */\n .bodythemelight {\n   background-color: $white-color;\n   padding-top: 90px;\n }\n \n .bodythemedark {\n   background-color: $darkTheme_blue;\n   padding-top: 90px;\n }\n \n /* \n Header Navbar Theme\n */\n .headerthemelight {\n   background-color: $white-color;\n }\n \n .headerthemedark {\n   background-color: $darkTheme_blue;\n }\n \n .top_header {\n   min-height: 90px;\n   display: flex;\n   align-items: center;\n   position: fixed;\n   width: 100%;\n   z-index: 2;\n   top: 0;\n }\n \n /* \n LEFT MENU THEME CHANGE\n */\n .menuthemelight {\n   background-color: $white-color;\n }\n \n .menuthemedark {\n   background-color: $darkTheme_blue;\n }\n \n /* \n LEFT MENU LINKS THEME CHANGE\n */\n .menulinklight span {\n   color: $placeholder-color !important;\n }\n \n .menulinklight a {\n   color: $menu_icon !important;\n }\n \n .menulinklight:hover span,\n .menulinklight:hover a {\n   color: $white-color !important;\n }\n \n .menulinkdarkSelected {\n   background-color: $darkTheme_selectBlue;\n   color: $dark-active-blue;\n }\n \n .menuthemelight .menulinklightSelected {\n   /*background-color: $lightthemecolor;*/\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinkdark {\n   color: $dark-light-blue !important;\n }\n \n .menulinklight:hover {\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinklight .sub_arrow svg path {\n   stroke: $menu_icon !important;\n }\n \n .menulinklight:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinkdark .sub_arrow svg path {\n   stroke: $dark-light-blue !important;\n }\n \n .menulinkdark:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinklight:hover svg path,\n .menulinklightSelected svg path {\n   fill: #fff !important;\n }\n \n .menulinkdark:hover {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n /* \n BODY HEADERS\n */\n .headinglight {\n   color: $lightthemetext;\n }\n \n .headingdark {\n   color: $lightthemetext;\n }\n \n /* \n SEARCH BOX THEME COLOR\n */\n .searchboxlight {\n   background-color: $white-color;\n   border: none;\n }\n \n .searchboxdark {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n   border: none;\n }\n \n .searchboxdark::placeholder {\n   color: $lightthemetext;\n }\n \n /* \n CUSTOM TABLE THEME COLOR\n */\n .tableheadlight {\n   background-color: $primary-color;\n   border-radius: 5px 5px 0px 0px;\n }\n \n .tableheadlight th {\n   color: $white-color;\n }\n \n thead .tableheadlight th:first-child,\n thead .tableheaddark th:first-child {\n   border-radius: 5px 0 0 0px;\n }\n \n thead .tableheadlight th:last-child,\n thead .tableheaddark th:last-child {\n   border-radius: 0 5px 0px 0;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n td:last-child {\n   border-radius: 0px;\n }\n \n table.table.table-borderless {\n   border-collapse: separate !important;\n   border-spacing: 0 0px !important;\n }\n \n .tableheaddark {\n   background-color: $primarydark-color;\n   color: $white-color;\n }\n \n .table-borderless tr:nth-child(even) {\n   background-color: #F9FAFB;\n }\n \n .table-borderless .left-section {\n   padding-top: 10px;\n }\n \n .tablebodylight td,\n .tablebodydark td {\n   padding: 0.5rem 1rem !important;\n   line-height: 45px;\n }\n \n .tablebodylight {\n   background-color: $white-color;\n \n   &:hover {\n     background-color: $white-color;\n     cursor: auto;\n   }\n }\n \n .tablebodydark {\n   /* background-color: $primarydark-color; */\n   color: $lightthemetext;\n \n   &:hover {\n     background-color: rgba(33, 150, 243, 0.1);\n     cursor: pointer;\n   }\n }\n \n /* \n PAGINATION THEME COLOR\n */\n .paginationlight {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n .paginationdark {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n /* \n SETTING FORM THEME COLOR\n */\n .formthemelight {\n   background-color: $white-color;\n   color: $black-color !important;\n   box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n }\n \n .formthemedark {\n   background-color: $primarydark-color;\n   color: $lightthemetext !important;\n   font-size: 14px;\n \n   ::placeholder {\n     color: $lightthemetext;\n   }\n }\n \n \n /* \n VIEW FORM DETAILS BOX THEME COLOR\n */\n .viewformlight {\n   background-color: $lightthemecolor;\n }\n \n .permissionboxlight {\n   background-color: #f8f9fa;\n   border: 1px solid #dee2e6;\n }\n \n .permissionboxdark {\n   background-color: $darkTheme_darkBlue;\n   border: solid 1px #242434;\n }\n \n .errormsgclr {\n   color: red;\n   font-size: 14px;\n   margin-top: 5px;\n }\n \n /* \n Graph theme\n */\n .graphclrlight {\n   background-color: $white-color;\n }\n \n .graphclrdark {\n   background-color: $primarydark-color;\n }\n \n \n /* \n Counter theme\n */\n #card1bglight {\n   /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card1bgdark {\n   background: #392f28;\n }\n \n #card2bglight {\n   /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card2bgdark {\n   background: #1c3238;\n }\n \n #card3bglight {\n   /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card3bgdark {\n   background: #3a2434;\n }\n \n #card4bglight {\n   /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card4bgdark {\n   background: #2f264f;\n }\n \n #card1bgdark a,\n #card1bgdark p,\n #card2bgdark a,\n #card2bgdark p,\n #card3bgdark a,\n #card3bgdark p,\n #card4bgdark a,\n #card4bgdark p {\n   color: $white-color;\n }\n \n /* \n Action button theme\n */\n .actionbtnlight {\n   color: #46475bde;\n }\n \n .actionbtndark {\n   color: $lightthemetext;\n }\n \n \n /* \n profile dropdowntheme\n */\n .profiledropdownlight {\n   background-color: #fff;\n }\n \n .profiledropdowndark {\n   background-color: #151521;\n }\n \n .settingsection #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .profile_conatiner {\n   border-radius: 5px !important;\n }\n \n .bodythemedark .ag-theme-alpine .ag-row {\n   background: #000 !important;\n }\n \n .bodythemedark .formbtn {\n   background-color: $addBtn-dark-blue;\n }\n \n .bodythemedark .formbtn:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .bodythemedark .resetbtn {\n   color: $white-color;\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n }\n \n \n .headingdark span {\n   background-color: $darkTheme_blue;\n }\n \n .resetbtn {\n   font-size: 16px !important;\n   font-weight: $font-semiBold !important;\n   border-radius: 5px !important;\n   background-color: transparent !important;\n   border: solid 1px $primary-color !important;\n   color: $primary-color !important;\n   min-width: 113px !important;\n }\n \n .resetbtn:hover,\n .resetbtn:active,\n .resetbtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n }\n \n .addBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n\n  .addDltBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n \n .addbtnlight {\n   background-color: $green-color;\n }\n \n .addbtndark {\n   background-color: $addBtn-dark-blue;\n }\n \n .addbtndark:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .formthemedark label {\n   color: $dark-light-blue;\n }\n \n \n .addBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: 2px;\n }\n \n .addBtn:hover {\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n }\n \n .cust_addBtn.addBtn svg {\n   top: 2px;\n }\n \n \n .deleteBtn {\n   min-width: 130px;\n   height: 50px;\n   background-color: $red-color;\n   color: $white-color;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n   border: none;\n }\n \n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .deleteBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: -2px;\n }\n \n .deleteBtn:hover,\n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color;\n   color: $white-color;\n   border: none;\n }\n \n .confirmBtn {\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  background-color: $primary-color !important;\n }\n\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .confirmBtn:hover,\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $darkTheme_darkBlue !important;\n }\n \n .confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n \n \n \n .delPopContainer .modal-body {\n   padding: 35px;\n   text-align: center;\n }\n \n .delPopContainer .delet_icon {\n   margin-bottom: 11px;\n }\n \n .delPopContainer p {\n   color: #131f43;\n   font-size: 14px;\n   font-weight: 700;\n   padding: 0 20px;\n }\n \n .arrowback svg {\n   fill: #000;\n }\n \n .bodythemedark .arrowback {\n   background-color: $backBtn-dark;\n   color: $dark-active-blue;\n }\n \n .bodythemedark .arrowback svg {\n   fill: $dark-active-blue;\n }\n \n .bodythemedark .drpdwn_btn {\n   background-color: $darkTheme_blue;\n }\n \n .bodythemedark .empname {\n   color: $dark-light-blue !important;\n }\n \n .bodythemedark .navitemli a {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingsgeneral,\n .bodythemedark .tabnavli a.settingslinks:hover {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingslinks {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a,\n .headerthemedark .dropdown_menu_contain .dropdown_item,\n .headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a:hover,\n .headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n }\n \n .dropdown_item:active {\n   background-color: $mainBg;\n }\n \n .profile_arrrow_dwn {\n   stroke: $darkTheme_blue;\n }\n \n .headerthemedark .profile_arrrow_dwn {\n   stroke: $white-color;\n }\n \n .dateinputbox1 input,\n .dateinputbox1 span {\n   color: $white-color !important;\n }\n \n /* LOGOUT MODAL */\n .modalStyleLight {}\n \n .modalStyleDark {}\n \n .delPopContainer .modal-content {\n   border-radius: 10px;\n   min-width: 399px;\n }\n \n .larg_model .modal-dialog {\n   max-width: 100% !important;\n }\n \n .larg_model .modal-content {\n   /* display: inline-block; */\n   height: 100%;\n   max-width: 900px;\n   margin: auto;\n   border-radius: 54px !important;\n   background: #FFF;\n   padding: 53px 53px 23px;\n }\n \n .larg_model .modal-header {\n   padding: 0px 0px 23px;\n   border-bottom: 1px dashed #D4D9EE;\n   display: block;\n }\n \n body .btn-primary:hover {\n   background-color: transparent;\n   border-color: #131F43;\n   color: #131F43;\n   fill: #131F43;\n   border: 1px solid;\n }\n \n .form-select {\n   display: block;\n   width: 100%;\n   padding: .375rem 2.25rem .375rem .75rem;\n   -moz-padding-start: calc(0.75rem - 3px);\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: #212529;\n   background-color: #fff;\n   background-image: url(../../assets/select_arow.svg) !important;\n }\n \n thead .CustomTable_tableheadlight__HuHZw th:first-child,\n thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n   border-radius: 5px 0 0 0px;\n   display: math;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n @media only screen and (max-width: 1200px) {\n   .tableheadlight th {\n     min-width: 170px;\n   }\n }\n \n @media only screen and (max-width: 1024px) {\n   .dashboard {\n     width: calc(100% - 50px) !important;\n     left: 50px !important;\n     padding: 10px 10px !important;\n     overflow-x: hidden;\n   }\n \n   .cont2 {\n     height: calc(100vh - 160px);\n     overflow-y: auto;\n   }\n }\n \n @media only screen and (max-width: 998px) {\n   /* #dashboardcont2{\n     height: auto !important;\n   }*/\n   /*.tableheadlight th {\n     min-width: 200px !important;\n   }*/\n }\n \n @media only screen and (max-width: 767px) {\n   .sectionright {\n     float: unset !important;\n   }\n .formthemelight {\n   padding: 10px 0!important;\n   box-shadow: none !important;\n }\n   .dashboard {\n     padding: 10px 10px !important;\n   }\n }\n \n @media only screen and (max-width: 600px) {\n   .cont2 {\n     width: $dashwidth !important;\n     left: $dashleft !important;\n     position: relative !important;\n     padding: 10px 10px 15px !important;\n   }\n \n   .bodythemelight,\n   .bodythemedark {\n     padding-top: 110px;\n   }\n \n   .delPopContainer .modal-content {\n     min-width: 100%;\n   }\n \n   .delPopContainer .modal-body {\n     padding: 15px;\n   }\n \n   .larg_model .modal-content {\n     border-radius: 20px !important;\n     padding: 22px;\n   }\n }\n \n @media (min-width: 576px) {\n   .exer_modal_contain .modal-dialog {\n     max-width: 1055px;\n   }\n \n   .delPopContainer .modal-dialog {\n     max-width: 350px;\n   }\n \n   /*.tableheadlight th {\n     min-width: 200px;\n   }*/\n }\n \n /* vk new changes */\n .active_show_outer {\n \n h2 {\n   color: var(--Font-black, #0B0D0F);\n   font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n   font-size: 22px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: normal;\n }\n \n   .active_show_inner {\n     width: 100%;\n     display: block;\n \n     .act_box_img {\n       margin-bottom: 12px;\n       min-height: 400px;\n       object-fit: cover;\n       overflow: hidden;\n       height: 400px;\n       max-height: 400px;\n       @media (max-width: 767px) {\n         min-height: 300px;\n         height: 300px;\n         max-height: 300px;\n       }\n       img {\n         max-height: 400px;\n         /* align-self: stretch; */\n         width: 100%;\n         height: 100%;\n         border-radius: 12px;\n         object-fit: cover;\n       }\n     }\n \n     .act_box_cnt {\n       width: 100%;\n       display: block;\n svg{\n  flex-shrink: 0;\n }\n       .act_box_bdg {\n         width: 100%;\n         margin-bottom: 12px;\n \n         span {\n           background: url(../../assets/ongoing.png) right top no-repeat;\n           width: 111px;\n           display: block;\n           height: 34px;\n           color: var(--White, #FFF);\n           font-size: 18px;\n           font-style: normal;\n           font-weight: 500;\n           padding: 3px 8px;\n         }\n \n         .sold {\n           background: url(../../assets/sold.png) right top no-repeat !important;\n         }\n \n       }\n \n       h3 {\n         color: var(--Secondary, #132941);\n         font-size: 18px;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 26.304px;\n         margin: 0;\n       }\n \n       p {\n         display: flex;\n         align-items: center;\n         gap: 10px;\n         margin-bottom: 5px;\n \n         span {\n           color: var(--Light-1, #736B66);\n           font-size: 14px;\n           font-style: normal;\n           font-weight: 500;\n           line-height: 26.304px;\n         }\n       }\n     }\n   }\n }\n \n /* vk new changes */\n .attent_details {\n   .attent_details_inner {\n     display: flex;\n     gap: 61px;\n     padding: 20px;\n     border-radius: 5px;\n     background: #FFF;\n     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n     align-items: center;\n \n     @media (max-width: 576px) {\n       display: block !important;\n     }\n \n     @media (max-width: 992px) {\n       display: flex;\n       gap: 20px;\n       align-items: start;\n     }\n \n     .attent_details_inner_l {\n       img {\n         width: 187px;\n         height: 207px;\n         flex-shrink: 0;\n         object-fit: contain;\n         @media screen and (max-width:767px) {\n          object-fit: contain;\n          width: auto;\n         }\n       }\n     }\n \n     .attent_details_inner_r {\n       flex: 1;\n \n       .attent_details_row {\n         display: flex;\n         gap: 20px;\n         margin-bottom: 28px;\n \n         @media (max-width: 992px) {\n           margin-bottom: 0px;\n           display: inline-block;\n           width: 100%;\n         }\n \n         .attent_details_row_box {\n           flex: 1;\n           width: 22%;\n \n           @media (max-width: 576px) {\n             margin: 15px 0px 10px !important;\n             width: 100% !important;\n           }\n \n           @media (max-width: 992px) {\n             margin-bottom: 15px;\n             float: left;\n             margin-right: 0;\n             width: 50%;\n             padding-right: 10px;\n           }\n \n           p {\n             margin-bottom: 10px;\n             color: #727272;\n             font-size: 13px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n           }\n \n           h5 {\n             color: #131F43;\n             font-size: 16px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n             word-wrap: break-word;\n           }\n         }\n       }\n \n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n     }\n   }\n }\n .showbox_sec {\n   display: grid;\n   grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n   gap: 20px;\n   align-items: stretch;\n   width: 100%;\n   @media screen and (max-width: 500px) {\n     grid-template-columns: 1fr;\n   }\n }\n .show_box_main {\n   margin: 10px 0px;\n   width: 100%;\n\n   .show_box {\n     min-height: 600px;\n     width: 100%;\n     margin-bottom: 0;\n     cursor: pointer;\n     display: flex;\n     flex-direction: column;\n     box-sizing: border-box;\n\n     @media (max-width: 767px) {\n       min-height: 500px;\n     }\n\n     .active_show_inner {\n       display: flex;\n       flex-direction: column;\n       flex: 1;\n       min-height: 0;\n     }\n\n     .act_box_img {\n       flex-shrink: 0;\n     }\n\n     .act_box_cnt {\n       flex: 1;\n       display: flex;\n       flex-direction: column;\n       min-height: 0;\n     }\n\n     img {\n       max-height: 400px;\n       height: 100%;\n       width: 100%;\n       object-fit: cover;\n\n       @media (max-width: 767px) {\n         max-height: 300px !important;\n       }\n     }\n\n     &:last-child {\n       margin-right: 0;\n     }\n   }\n \n   .no_show_box {\n     width: 350px;\n     margin: 0 auto 20px;\n     display: block;\n   \n     @media (max-width: 767px) {\n       width: 250px !important;\n     }\n   \n     img {\n       max-height: 450px;\n       height: 100%;\n       width: 100%;\n   \n       @media (max-width: 767px) {\n         max-height: 350px !important;\n       }\n     }\n     h6 {\n       color: #000;\n       text-align: center;\n       font-size: 26px;\n       font-style: normal;\n       font-weight: 700;\n       line-height: normal;\n       margin-top: 20px;\n       @media only screen and (max-width: 600px) {\n         font-size: 20px;\n       }\n     }\n   }\n   \n \n }\n \n .attent_flex {\n   justify-content: space-between !important;\n   gap: 30px;\n   align-items: center;\n \n   h5 {\n     font-size: 22px;\n     font-style: normal;\n     font-weight: 700;\n   }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `Pagination_dashboard__kQixg`,
	"dashboardContain": `Pagination_dashboardContain__0pA47`,
	"bodythemedark": `Pagination_bodythemedark__OgYY8`,
	"cont2": `Pagination_cont2__SZIEC`,
	"top_header": `Pagination_top_header__H-Oco`,
	"top_header_inner": `Pagination_top_header_inner__PaHcf`,
	"subLink": `Pagination_subLink__ZBQ8s`,
	"cst_vendr": `Pagination_cst_vendr__rcwk-`,
	"form-control": `Pagination_form-control__M0GGh`,
	"footer": `Pagination_footer__b0mH-`,
	"bodythemelight": `Pagination_bodythemelight__R2JcG`,
	"headerthemelight": `Pagination_headerthemelight__-7Cfo`,
	"headerthemedark": `Pagination_headerthemedark__r4EaC`,
	"menuthemelight": `Pagination_menuthemelight__k4gQv`,
	"menuthemedark": `Pagination_menuthemedark__cLgRf`,
	"menulinklight": `Pagination_menulinklight__sX78A`,
	"menulinkdarkSelected": `Pagination_menulinkdarkSelected__EVStZ`,
	"menulinklightSelected": `Pagination_menulinklightSelected__zrpEN`,
	"menulinkdark": `Pagination_menulinkdark__eL8OR`,
	"sub_arrow": `Pagination_sub_arrow__lVVDH`,
	"headinglight": `Pagination_headinglight__35cyh`,
	"headingdark": `Pagination_headingdark__36KvX`,
	"searchboxlight": `Pagination_searchboxlight__s+wm4`,
	"searchboxdark": `Pagination_searchboxdark__0RZjp`,
	"tableheadlight": `Pagination_tableheadlight__BaqoI`,
	"tableheaddark": `Pagination_tableheaddark__5KsVI`,
	"table": `Pagination_table__y5zmQ`,
	"table-borderless": `Pagination_table-borderless__xibJL`,
	"left-section": `Pagination_left-section__hQaak`,
	"tablebodylight": `Pagination_tablebodylight__E3aoH`,
	"tablebodydark": `Pagination_tablebodydark__Bb46b`,
	"paginationlight": `Pagination_paginationlight__1TgmT`,
	"paginationdark": `Pagination_paginationdark__AEqE5`,
	"formthemelight": `Pagination_formthemelight__zzVIW`,
	"formthemedark": `Pagination_formthemedark__E4MYO`,
	"viewformlight": `Pagination_viewformlight__fVh6N`,
	"permissionboxlight": `Pagination_permissionboxlight__lbbP-`,
	"permissionboxdark": `Pagination_permissionboxdark__yFS4k`,
	"errormsgclr": `Pagination_errormsgclr__VLqeq`,
	"graphclrlight": `Pagination_graphclrlight__1ZNHL`,
	"graphclrdark": `Pagination_graphclrdark__UXGf8`,
	"card1bglight": `Pagination_card1bglight__Olemd`,
	"card1bgdark": `Pagination_card1bgdark__OdKzz`,
	"card2bglight": `Pagination_card2bglight__Wpqrw`,
	"card2bgdark": `Pagination_card2bgdark__sjBGc`,
	"card3bglight": `Pagination_card3bglight__EeWN-`,
	"card3bgdark": `Pagination_card3bgdark__JuixI`,
	"card4bglight": `Pagination_card4bglight__Uqrm4`,
	"card4bgdark": `Pagination_card4bgdark__OEsuw`,
	"actionbtnlight": `Pagination_actionbtnlight__ynj7y`,
	"actionbtndark": `Pagination_actionbtndark__HO3Fe`,
	"profiledropdownlight": `Pagination_profiledropdownlight__fmco2`,
	"profiledropdowndark": `Pagination_profiledropdowndark__7OCJb`,
	"settingsection": `Pagination_settingsection__rvauY`,
	"addform": `Pagination_addform__XTerP`,
	"savebtn": `Pagination_savebtn__JqaFq`,
	"profile_conatiner": `Pagination_profile_conatiner__rupz3`,
	"ag-theme-alpine": `Pagination_ag-theme-alpine__47q7Y`,
	"ag-row": `Pagination_ag-row__nwqt5`,
	"formbtn": `Pagination_formbtn__RbqfV`,
	"resetbtn": `Pagination_resetbtn__xXX2V`,
	"addBtn": `Pagination_addBtn__+WUXn`,
	"addDltBtn": `Pagination_addDltBtn__AXGDA`,
	"addbtnlight": `Pagination_addbtnlight__QNxNJ`,
	"addbtndark": `Pagination_addbtndark__d2DZB`,
	"cust_addBtn": `Pagination_cust_addBtn__fL0mq`,
	"deleteBtn": `Pagination_deleteBtn__m2QAL`,
	"confirmBtn": `Pagination_confirmBtn__kkMo9`,
	"delPopContainer": `Pagination_delPopContainer__Oj84z`,
	"modal-body": `Pagination_modal-body__w9Cdn`,
	"delet_icon": `Pagination_delet_icon__BmG-y`,
	"arrowback": `Pagination_arrowback__12gk0`,
	"drpdwn_btn": `Pagination_drpdwn_btn__0KUs7`,
	"empname": `Pagination_empname__9jb80`,
	"navitemli": `Pagination_navitemli__SgTIi`,
	"tabnavli": `Pagination_tabnavli__3aDRL`,
	"settingsgeneral": `Pagination_settingsgeneral__Nxyzg`,
	"settingslinks": `Pagination_settingslinks__Fsoxr`,
	"dropdown_menu_contain": `Pagination_dropdown_menu_contain__XzqCH`,
	"dropdown_item": `Pagination_dropdown_item__ur5Ww`,
	"profile_arrrow_dwn": `Pagination_profile_arrrow_dwn__YcNXw`,
	"dateinputbox1": `Pagination_dateinputbox1__BKBu0`,
	"modal-content": `Pagination_modal-content__SNELE`,
	"larg_model": `Pagination_larg_model__szvQz`,
	"modal-dialog": `Pagination_modal-dialog__0DqCk`,
	"modal-header": `Pagination_modal-header__X4FDv`,
	"btn-primary": `Pagination_btn-primary__mnYEd`,
	"form-select": `Pagination_form-select__ZZaBk`,
	"CustomTable_tableheadlight__HuHZw": `Pagination_CustomTable_tableheadlight__HuHZw__YIjmn`,
	"CustomTable_tableheaddark__nwqb4": `Pagination_CustomTable_tableheaddark__nwqb4__Jsrb+`,
	"sectionright": `Pagination_sectionright__Ezc2w`,
	"exer_modal_contain": `Pagination_exer_modal_contain__bVktO`,
	"active_show_outer": `Pagination_active_show_outer__Wb6Qc`,
	"active_show_inner": `Pagination_active_show_inner__b0ocm`,
	"act_box_img": `Pagination_act_box_img__Eddye`,
	"act_box_cnt": `Pagination_act_box_cnt__Kzf69`,
	"act_box_bdg": `Pagination_act_box_bdg__y-hW5`,
	"sold": `Pagination_sold__TpiZ2`,
	"attent_details": `Pagination_attent_details__IvL4J`,
	"attent_details_inner": `Pagination_attent_details_inner__vs9YP`,
	"attent_details_inner_l": `Pagination_attent_details_inner_l__-yHre`,
	"attent_details_inner_r": `Pagination_attent_details_inner_r__BTOR0`,
	"attent_details_row": `Pagination_attent_details_row__1DAxv`,
	"attent_details_row_box": `Pagination_attent_details_row_box__6CrqC`,
	"attent_details_row_last": `Pagination_attent_details_row_last__T-LxK`,
	"interesting_fact": `Pagination_interesting_fact__9CM5p`,
	"showbox_sec": `Pagination_showbox_sec__1M1wo`,
	"show_box_main": `Pagination_show_box_main__K+oVW`,
	"show_box": `Pagination_show_box__NjU3V`,
	"no_show_box": `Pagination_no_show_box__TTkk0`,
	"attent_flex": `Pagination_attent_flex__oELv1`,
	"paginationright": `Pagination_paginationright__cXPdT`,
	"pagetext": `Pagination_pagetext__NdLdG`,
	"pagebtn": `Pagination_pagebtn__5LODQ`,
	"paginations_bg": `Pagination_paginations_bg__zVk6n`,
	"pageof": `Pagination_pageof__o-11s`,
	"total_users": `Pagination_total_users__Awa0w`,
	"paginationm_container": `Pagination_paginationm_container__hfKJW`,
	"active": `Pagination_active__q3h4d`,
	"pagination_next": `Pagination_pagination_next__HgofK`,
	"pagination": `Pagination_pagination__mVvOv`
};
export default ___CSS_LOADER_EXPORT___;
